import { render, staticRenderFns } from "./SponsorSeatGrid.vue?vue&type=template&id=53e3654e&scoped=true&"
import script from "./SponsorSeatGrid.vue?vue&type=script&lang=js&"
export * from "./SponsorSeatGrid.vue?vue&type=script&lang=js&"
import style0 from "./SponsorSeatGrid.vue?vue&type=style&index=0&id=53e3654e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e3654e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VIcon})
